export default __webpack_public_path__ + "static/media/5.ea3d479e.png";